<template>
  <el-dialog
    :title="$t('chainProduct.editProduct')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px" :show-message="false">
      <el-form-item :label="$t('chainProduct.productName')" prop="prodName">
        <el-input v-model="formData.prodName" />
      </el-form-item>
      <el-form-item :label="$t('chainProduct.productCategory')" prop="categoryId">
        <el-select
          v-model="formData.categoryId"
          :placeholder="$t('chainProduct.selectCategory')"
          style="width:100%"
        >
          <el-option
            v-for="item in categoryOptions"
            :key="item.categoryId"
            :label="item.categoryName"
            :value="item.categoryId"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('chainProduct.productUnit')" prop="unitName">
        <el-input v-model="formData.unitName" />
      </el-form-item>
      <el-form-item :label="$t('chainProduct.sort')">
        <el-input-number v-model="formData.sort" :min="0" />
      </el-form-item>
      <el-form-item :label="$t('chainProduct.status')" prop="state">
        <el-radio-group v-model="formData.state">
          <el-radio label="2002">{{ $t('chainProduct.onShelf') }}</el-radio>
          <el-radio label="2003">{{ $t('chainProduct.offShelf') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateChainProduct } from '@/api/admin/chainProduct/chainProductApi'
import { productFormRules } from '@/utils/productFormRules'

export default {
  name: 'EditProduct',
  data() {
    return {
      dialogVisible: false,
      rules: {
        prodName: productFormRules.prodName,
        categoryId: productFormRules.categoryId,
        unitName: productFormRules.unitName,
        state: productFormRules.state
      },
      formData: {
        productId: '',
        prodName: '',
        categoryId: '',
        unitName: '',
        sort: 0,
        state: '2002'
      },
      categoryOptions: []
    }
  },
  methods: {
    open(product) {
      this.formData = { ...product }
      this.categoryOptions = this.$parent.chainProductInfo.catalogs
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async handleSubmit() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) {
          this.$message.warning('商品信息还有未填写的内容，请填写完整')
          return
        }

        await updateChainProduct(this.formData)
        this.$message.success(this.$t('common.updateSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('Update product failed:', error)
      }
    }
  }
}
</script>